<template>
  <div class="adtpl-wrap">
    <div class="table-wrap">
      <div class="table-header">
        <el-select style="width: 160px" v-model="filterData.creator" @change="searchData">
          <el-option label="全部创建者" :value="-1"> </el-option>
          <el-option v-for="item of createrList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
        <el-select style="width: 160px; margin-left: 20px" v-model="filterData.version" @change="searchData">
          <el-option label="头条1.0" value="v1"> </el-option>
          <el-option label="头条2.0" value="v2"> </el-option>
        </el-select>
        <el-input
          placeholder="请输入内容"
          suffix-icon="el-icon-search"
          v-model="filterData.search"
          style="width: 160px; margin-left: auto"
          @input="inputSearch"
        >
        </el-input>
      </div>
      <el-table :data="tableData" style="width: 100%" height="calc(100vh - 210px)">
        <el-table-column prop="platform" label="广告平台"> </el-table-column>
        <el-table-column prop="templateName" label="模板名称"> </el-table-column>
        <el-table-column prop="creator" label="创建者"> </el-table-column>
        <el-table-column prop="createTimeStr" label="创建时间"> </el-table-column>
        <el-table-column prop="modifyTimeStr" label="模板更新时间"> </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="deleteTpl(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getCreator, queryAdTemplate, deleteAdTemplate } from "@/api/platReport.js";
export default {
  name: "AdTemplate",
  mounted() {
    this.initSelect();
    this.searchFirstPage();
  },
  data() {
    return {
      createrList: [],
      filterData: {
        creator: -1,
        version: "v1",
        search: "",
      },
      pageData: {
        total: 15,
        size: 10,
        page: 1,
      },
      tableData: [],
      timer: null,
    };
  },
  methods: {
    initSelect() {
      getCreator().then((res) => {
        if (res.code === "0000") {
          this.createrList = res.creators;
        }
      });
    },
    formatData() {
      let parmas = {
        page: this.pageData.page,
        size: this.pageData.size,
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (parmas[key] = checkData.join());
        } else {
          parmas[key] = checkData;
        }
      }
      return parmas;
    },
    searchData() {
      let parmas = this.formatData();
      queryAdTemplate(parmas).then((res) => {
        if (res.code === "0000") {
          this.tableData = res.adTemplates;
          this.pageData.total = res.count;
        }
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    searchFirstPage() {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData();
    },
    deleteTpl(item) {
      this.$confirm("确定删除该广告模板?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAdTemplate({ id: item.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "模板删除成功",
                type: "success",
              });
              this.searchData();
            }
          });
        })
        .catch(() => {});
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.searchFirstPage();
      }, 300);
    },
  },
};
</script>

<style lang="less" scoped>
.adtpl-wrap {
  padding: 16px;
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .table-header {
      display: flex;
      margin-bottom: 16px;
    }
  }
}
</style>
